export default "__VITE_ASSET__cKZAJ0ug__"